import React, { useState } from "react";
import SearchBar from "../../components/SearchBar";
import Navbar from "../../components/Navbar";
import hamburger_icon from "../../assets/icons/hamburger_icon.png";
import lightMode_icon from "../../assets/icons/lightMode_icon.png";
import darkMode_icon from "../../assets/icons/darkMode_icon.png";
import systemMode_icon from "../../assets/icons/systemMode_icon.png";
import ThemeChanged from "../../components/modals/ThemeChanged";

const Theme = () => {
  const [isNavbarVisible, setIsNavbarVisible] = useState(false);
  const [mode, setMode] = useState("light");
  const [saveChange, setSaveChange] = useState(false);

  const toggleNavbar = () => {
    setIsNavbarVisible(!isNavbarVisible);
  };

  const closeModal = () => {
    setSaveChange(false);
  };
  return (
    <div>
      <div className="flex items-center justify-center w-full">
        <div
          className="items-center justify-center hidden hamburger"
          onClick={toggleNavbar}
        >
          <img
            src={hamburger_icon}
            alt="hamburger"
            className="object-contain"
          />
        </div>
        <div className="flex items-center justify-center w-full">
          <SearchBar categoryName="Profile" />
        </div>
        <div className="absolute top-0 w-[70%] z-20 bg-white rounded-lg mt-16">
          {isNavbarVisible && <Navbar />}
        </div>
      </div>

      <div className="ml-4 mt-10">
        <p className="text-[18px] font-bold">Theme</p>
        <p className="text-[14px] text-[#828282] italic">Mode</p>
      </div>

      <div className="flex justify-around mt-16 w-[90%] flex--cards">
        <div
          className="flex flex-col items-center cursor-pointer"
          onClick={() => setMode("light")}
        >
          <div
            className={`${
              mode === "light" ? "border-4" : ""
            } border-[#F6B801] rounded-3xl`}
          >
            <img src={lightMode_icon} alt="light mode" />
          </div>
          <p className="mt-2">Light mode</p>
        </div>
        <div
          className="flex flex-col items-center cursor-pointer"
          onClick={() => setMode("dark")}
        >
          <div
            className={`${
              mode === "dark" ? "border-4" : ""
            } border-[#F6B801] rounded-3xl`}
          >
            <img src={darkMode_icon} alt="light mode" />
          </div>
          <p className="mt-2">Dark mode</p>
        </div>
        <div
          className="flex flex-col items-center cursor-pointer"
          onClick={() => setMode("system")}
        >
          <div
            className={`${
              mode === "system" ? "border-4" : ""
            } border-[#F6B801] rounded-3xl`}
          >
            <img src={systemMode_icon} alt="light mode" />
          </div>
          <p className="mt-2">System mode</p>
        </div>
      </div>

      <div className="mt-28 my-4 flex justify-center w-[90%]">
        <div
          className="text-[#2F80ED] border text-center border-[#2F80ED] rounded-lg w-[15rem] font-bold p-1 cursor-pointer"
          onClick={() => setSaveChange(true)}
        >
          Save Changes
        </div>
      </div>
      {saveChange ? <ThemeChanged closeModal={closeModal} /> : ""}
    </div>
  );
};

export default Theme;
